export enum CreditPolicyUseCase {
  CreditPolicy = 0,
  ScoringIndicator
}